export default __webpack_public_path__ + "static/DSC_0146-1ffb3037831d1da75304528da2a56281.jpg";